
import React from 'react';
import { FaBars, FaTimes } from "react-icons/fa";
import logo from '../assets/logo1.png';  
import BookingForm from './BookingForm';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [bookingOpen, setBookingOpen] = React.useState(false);

  return (
    <>
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between relative">

          {/* LEFT - LOGO + TEXT */}
          <div className="flex items-center gap-3">
            <img 
              src={logo} 
              alt="Logo"
              className="w-14 h-15 object-cover rounded-full border"
            />
            <div className="flex flex-col">
              <div className="text-xl font-bold text-red-700">
                LABTOUCH PATHOLOGY LAB 
              </div>
              <p className="text-sm text-gray-600 italic leading-none">
                Fast is fine, but accuracy is everything.
              </p>
            </div>
          </div>

          {/* NAV LINKS - Desktop */}
          <nav className="hidden md:flex items-center gap-6 text-gray-700 font-medium">
            <a href="#doctors" className="hover:text-red-600">Admin</a>
            <a href="#home" className="hover:text-red-600">Home</a>
            <a href="#about" className="hover:text-red-600">About</a>
            <a href="#services" className="hover:text-red-600">Services</a>
            
            <a href="#reviews" className="hover:text-red-600">Review</a>
            <a href="#gallery" className="hover:text-red-600">Gallery</a>
            <a href="#contact" className="hover:text-red-600">Contact</a>
          </nav>

          {/* Mobile Menu Button + Home Collection Badge */}
          <div className="flex items-center gap-4 relative">

            {/* Mobile Menu Button */}
            <div className="md:hidden ml-2">
              {mobileMenuOpen ? (
                <FaTimes
                  className="cursor-pointer text-2xl"
                  onClick={() => setMobileMenuOpen(false)}
                />
              ) : (
                <FaBars
                  className="cursor-pointer text-2xl"
                  onClick={() => setMobileMenuOpen(true)}
                />
              )}
            </div>

            {/* Home Collection Badge */}
            <div 
              className="absolute top-full mt-7 right-1 bg-green-600 text-white text-xs px-3 py-1 rounded-md shadow-lg whitespace-nowrap 
                         cursor-pointer animate-pulse-zoom hover:bg-green-700"
              onClick={() => setBookingOpen(true)}
            >
              Contact For Home Collection<br />7507630030
            </div>

          </div>

        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="md:hidden bg-white shadow-lg flex flex-col gap-4 px-6 py-4">
             <a href="#doctors" className="hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Admin</a>
            <a href="#home" className="hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Home</a>
            <a href="#about" className="hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>About</a>
            <a href="#services" className="hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Services</a>
           
            <a href="#reviews" className="hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Review</a>
            <a href="#gallery" className="hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Gallery</a>
            <a href="#contact" className="hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>Contact</a>
          </nav>
        )}
      </header>

      {/* Booking Form */}
      <BookingForm 
        open={bookingOpen} 
        onClose={() => setBookingOpen(false)} 
        testName="Home Collection" 
      />
    </>
  );
}



